export default function arrayUtils(store) {
  store.comparer = (arrayToCompare) => {
    return function (current) {
      return arrayToCompare.filter((other) => {
        return other.key === current.key && other.display === current.display
      }).length === 0;
    }
  }
  return 'hello'
}
